import { getUserData } from '@/core/auth/utils'

import { getForemanOrderRow } from '../utils/utils'

import { STATUSES_FOR_FILTER } from './actions'

const STATUSES_FOR_CHANGE = ['completed', 'delivered', 'on_the_way']

export default {
    ADD_TO_ORDERS(state, lists) {
        const searches = []
        if (lists != null) {
            lists.forEach(e => {
                searches.push(getForemanOrderRow(e))
            })
            state.orders = searches
        } else {
            state.orders = []
        }
    },
    SET_COURIER(state, val) {
        state.previewOrder = {
            ...state.previewOrder,
            courier: val,
            courier_id: val.id,
        }
    },
    SET_RESTAURANT(state, restaurant) {
        state.restaurant = restaurant
    },
    ADD_ORDER(state, order) {
        state.orders.unshift(getForemanOrderRow(order))
    },
    SET_COUNT(state, count) {
        state.totalOrders = count
    },
    SET_PARAMS(state, params) {
        state.paramsSearch = {
            statuses:
                !params.statuses || !params.statuses.length
                    ? state.statuses.map(item => item.id)
                    : params.statuses,
            deps: state.paramsSearch.deps,
            ...params,
        }
    },
    ADD_TO_STATUSES(state, statuses) {
        state.statuses = []
        state.statusesForChange = []
        statuses
            ?.filter(e => STATUSES_FOR_FILTER.includes(e.id))
            .forEach(e => {
                state.statuses.push(e)
            })
        statuses
            ?.filter(e => STATUSES_FOR_CHANGE.includes(e.id))
            .forEach(e => {
                state.statusesForChange.push(e)
            })
    },
    ADD_COURIERS(state, couriers) {
        couriers.forEach(e => {
            if (!state.couriers.find(c => c.id === e.id)) {
                state.couriers.push(e)
            }
        })
    },
    CLEAR_COURIERS(state) {
        state.couriers = []
    },
    SET_COURIERS(state, couriers) {
        state.couriersByRestaurant = couriers
    },
    SET_PREVIEW_ORDER(state, { data }) {
        if (!data.order) {
            return
        }

        if (!state.previewOrder) {
            state.previewOrder = {
                address: null,
                payments: [],
                promos: [],
                dishes: [],
                courier: null,
                id: null,
                editable: true,
                division_id: null,
                fiscal_required: false,
            }
        }

        const orderData = structuredClone(data.order)

        state.previewOrder = {
            ...state.previewOrder,
            ...data.order,
            payments: Array.isArray(orderData.payments)
                ? data.order.payments
                : [],
            address: orderData.address,
            promos: Array.isArray(orderData.promos) ? data.order.promos : [],
            dishes: Array.isArray(orderData.dishes) ? data.order.dishes : [],
            courier: orderData.courier ?? null,
            editable: !data.lock_by_user,
            lock_by_user: data.lock_by_user || null,
            id: orderData.id ?? null,
            fiscal_required: orderData.fiscal_required ?? false,
        }
    },

    SET_CHANGES_ORDER(state, { data }) {
        state.changesOrder = data.changes || []
    },

    SET_PRINTED_ORDERS(state, printedOrders) {
        state.printedOrders = printedOrders
    },

    SET_UNPRINTED_INVOICES(state, unprintedInvoices) {
        state.unprintedInvoices = unprintedInvoices
    },

    SET_PRINTED_INVOICES_COUNT(state, count) {
        state.printedInvoicesCount = count
    },

    SET_MULTIPRINT_STATUS(state, status) {
        state.isMultiPrintInProgress = status
    },

    SET_MULTIPRINT_JOB(state, job) {
        state.multiPrintJob = job
        state.isMultiPrintInProgress = Boolean(job)
    },

    UPDATE_MULTIPRINT_JOB(state, payload) {
        if (!state.multiPrintJob) return
        state.multiPrintJob = { ...state.multiPrintJob, ...payload }
    },

    CLEAR_MULTIPRINT_JOB(state) {
        state.multiPrintJob = null
        state.isMultiPrintInProgress = false
    },

    SET_MENU(state, { data }) {
        // todo error
        state.menu = data.menu_item
        state.menuTotal = data.menu_item_aggregate.aggregate.count
    },
    ADD_TO_MENU(state, { data }) {
        state.menu = [...state.menu, ...data.menu_item]
        state.menuTotal = data.menu_item_aggregate.aggregate.count
    },
    ADD_NOTIFICATIONS(state, notifications) {
        if (!notifications) return
        if (!state.notifications) state.notifications = []
        const newNtfs = notifications.filter(
            e => !state.notifications.find(e1 => e1.id === e.id)
        )
        state.notifications = [...state.notifications, ...newNtfs]

        if (!state.selectedNotify) {
            const firstRow = [...state.notifications].sort(
                (a, b) => new Date(b.created_date) - new Date(a.created_date)
            )[0]
            state.selectedNotify = firstRow.order_id
        }
    },
    SET_SELECTED_NOTIFY_FIRST(state) {
        const firstRow = [...state.notifications].sort(
            (a, b) => new Date(b.created_date) - new Date(a.created_date)
        )[0]
        state.selectedNotify = firstRow.order_id
    },
    CLEAR_NOTIFICATIONS(state) {
        state.notifications = []
    },
    SET_DIVISIONS(state, divisions) {
        state.divisions = divisions
    },

    DELETE_NOTIFICATION(state, ids) {
        if (!state.notifications) return

        state.notifications = state.notifications.filter(e => {
            return !ids.includes(e.id)
        })
    },
    SET_SELECTED_NOTIFY(state, value) {
        state.selectedNotify = value
    },

    INIT_PARAMS_SEARCH(state) {
        const { user } = getUserData()

        state.paramsSearch = {
            ...state.paramsSearch,
            deps: user?.divisions?.map(item => item.id) || [],
        }
    },
}
